import { differenceInSeconds, formatDistanceToNowStrict } from 'date-fns'
import { QUARTER_END, QUARTER_START, RESULTS_DATE } from './scoring.js'

export function quarterTimeRemaining(now = new Date()) {
  const totalSeconds = Math.max(0, differenceInSeconds(QUARTER_END, now))
  const days = Math.floor(totalSeconds / 86400)
  const hours = Math.floor((totalSeconds % 86400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  return { days, hours, minutes, totalSeconds, ended: totalSeconds === 0 }
}

export function quarterProgress(now = new Date()) {
  const total = QUARTER_END.getTime() - QUARTER_START.getTime()
  const elapsed = now.getTime() - QUARTER_START.getTime()
  if (elapsed <= 0) return 0
  if (elapsed >= total) return 1
  return elapsed / total
}

export function timeUntilResults(now = new Date()) {
  if (now >= RESULTS_DATE) return 'Live now'
  return formatDistanceToNowStrict(RESULTS_DATE, { addSuffix: true })
}

export function isQuarterLive(now = new Date()) {
  return now >= QUARTER_START && now <= QUARTER_END
}

export function relativeTime(date) {
  if (!date) return ''
  return formatDistanceToNowStrict(new Date(date), { addSuffix: true })
}
